
<div *ngIf="AS.errorInfo || !MYSTATUS.disclaimerAccepted; else ok"></div>
<ng-template #ok>
<!-- MAP -->
<app-position-manager id="position-manager" #position
  *ngIf="!AS.errorInfo && AS.appReady && !!MYSTATUS"
  [AS]="AS" [MYSTATUS]="MYSTATUS"
  [ngStyle]="{'display': ((AS.appModes.length === 0 && false) || AS.appInMultimedia) ? 'none' : 'flex'}">
</app-position-manager>

<app-multimedia-manager-caller #multimediamanager id="multimedia-manager-container"
  [AS]="AS" [MYSTATUS]="MYSTATUS" [PRIMARYSTATUS]="PRIMARYSTATUS"
  [ngStyle]="{'display': AS.appInMultimedia ? 'flex' : 'none'}">
</app-multimedia-manager-caller>
<div id="button-container-new" *ngIf="!AS.appInMultimedia && AS.appModes.length > 0 && MYSTATUS.disclaimerAccepted && AS.session.config.localization">
  <button mat-raised-button class="bottom-button" #multimediaButton
    *ngIf="AS.session.config.audio || AS.session.config.video || AS.session.config.customerAttachments || AS.session.config.chat"
    [matBadge]="AS.unreadMessage" [matBadgeHidden]="!AS.unreadMessage" matBadgePosition="above after" matBadgeColor="warn"
    [disabled]="AS.sessionExpired || AS.commandsDisabled || !(config.partecipantsStatus$ | targetPresence)" (click)="showMultimediaDialog()">
    {{ 'BUTTONS.MULTIMEDIA' | translate}}
  </button>
  <button mat-raised-button class="bottom-button"
    [disabled]="!(MYSTATUS.isRegistered ) || AS.sessionExpired || MYSTATUS.geoLocPermissionGiven == 2 || !session.config.localization"
    (click)="sendLocationImmediately()">
    {{ 'BUTTONS.SENDPOSITION' | translate}}
  </button>
</div>

<!-- WELCOME SECTION OVERLAY -->
<div id="welcome-overlay" *ngIf="!this.config.operatorsStatus.length && (AS.appModes.length === 0 || true) && !config.iamOnCall">
  <div id="welcome-section">
    <div id="welcome-msg">
      <div id="welcome-txt">
        <div id="welcome-title">{{'help.WELCOMEMESSAGE' | translate}} <b>{{title}}</b></div>
        <div id="welcome-connection-status">
          <app-status-circle
            [color]="(MYSTATUS | statusColor).color"
            [tooltip]="(MYSTATUS | statusColor).tooltip"
          ></app-status-circle>
          <div [ngClass]="{ 'loading' : !MYSTATUS.isRegistered }" class="connection-status">
            {{ MYSTATUS.isRegistered ? ('LABELS.CONNECTEDSIP' | translate) :
              ('LABELS.CONNECTINGSIP' | translate) }}
          </div>
        </div>
        <div id="welcome-connection-status" *ngIf="MYSTATUS.isRegistered">

          <app-status-circle
            [color]="(config.partecipantsStatus$ | targetPresence) ? 'var(--status-green)' : 'var(--status-red)'"

          ></app-status-circle>

          <div [ngClass]="{ 'loading' : !(config.partecipantsStatus$ | targetPresence)}" class="connection-status">
            {{ !(config.partecipantsStatus$ | targetPresence) ? ('help.WELCOMEMESSAGEWAIT' | translate) : ('help.WELCOMEMESSAGEWAIT' | translate)}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</ng-template>
